export const acceptedImages = {
  'image/jpg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
};

export const KEYS = {
  MAX_FILE_SIZE_IN_MB: 1,
};
